<script setup>
  import DropdownWidget from "./dropdown-widget.vue";

  import {
    breakdownRecipePath,
    costRecipePath,
    editRecipePath,
    historyRecipePath,
    ingredientMetasRecipePath,
    ingredientAllergensRecipePath,
    recipeCardRecipePath,
    recipePath,
  } from "routes";

  defineProps({
    recipe: { type: Object, required: true },
  });
</script>

<template>
  <DropdownWidget>
    <template #trigger>
      <button class="button is-info is-small">
        <span>Pages</span>
        <span class="icon is-small">
          <i class="fas fa-angle-down"></i>
        </span>
      </button>
    </template>

    <template #content>
      <a class="dropdown-item" :href="editRecipePath(recipe.id)">
        <span class="icon-text">
          <span class="icon">
            <i class="fa fa-edit"></i>
          </span>
          <span>Recipe</span>
        </span>
      </a>

      <div v-if="!recipe.empty">
        <a class="dropdown-item hide-personal" :href="recipePath(recipe.id)">
          <span class="icon-text">
            <span class="icon">
              <i class="fa fa-eye"></i>
            </span>
            <span>Label</span>
          </span>
        </a>

        <a class="dropdown-item hide-personal" :href="ingredientMetasRecipePath(recipe.id)">
          <span class="icon-text is-flex-wrap-nowrap">
            <span class="icon">
              <i class="fa-duotone fa-list"></i>
            </span>
            <span>Ingredient Statement</span>
          </span>
        </a>

        <a class="dropdown-item hide-personal" :href="ingredientAllergensRecipePath(recipe.id)">
          <span class="icon-text is-flex-wrap-nowrap">
            <span class="icon">
              <i class="fa-regular fa-peanuts"></i>
            </span>
            <span>Allergens</span>
          </span>
        </a>

        <a class="dropdown-item hide-personal" :href="costRecipePath(recipe.id)">
          <span class="icon-text">
            <span class="icon">
              <i class="fa fa-dollar-sign"></i>
            </span>
            <span>Cost</span>
          </span>
        </a>

        <a class="dropdown-item" :href="breakdownRecipePath(recipe.id)">
          <span class="icon-text is-flex-wrap-nowrap">
            <span class="icon">
              <i class="fa-duotone fa-grid-2"></i>
            </span>
            <span>Nutrition Breakdown</span>
          </span>
        </a>

        <a class="dropdown-item hide-personal" :href="recipeCardRecipePath(recipe.id)">
          <span class="icon-text">
            <span class="icon">
              <i class="far fa-rectangle-list"></i>
            </span>
            <span>Card</span>
          </span>
        </a>

        <a class="dropdown-item hide-personal" :href="historyRecipePath(recipe.id)">
          <span class="icon-text">
            <span class="icon">
              <i class="fa fa-clock-rotate-left"></i>
            </span>
            <span>History</span>
          </span>
        </a>
      </div>
    </template>
  </DropdownWidget>
</template>
